@if (activeUblPreview(); as preview) {
  <wf-peppol-ubl-preview [ublPreview]="preview" [detail]="detail()" />
} @else if (showUnavailablePreview()) {
  <div class="wf-peppol-detail-preview__empty">
    <wf-big-icon
      relative
      iconsPath="assets/images/icons/file.svg"
      [iconWidth]="120"
      [iconHeight]="163"
      [title]="'PEPPOL.Preview.UnavailableTitle' | translate"
      [description]="'PEPPOL.Preview.UnavailableDescription' | translate"
    />
  </div>
} @else {
  <wui-file-preview
    hideSourceTitle
    bottomGap
    [source]="filePreviewSource()"
    [isEmpty]="!filePreviewSource()"
    [emptySubtitle]="'EMPTY_STATES.PREVIEW.Subtitle' | translate"
  />
}
